<app-citizen-header></app-citizen-header>

<div class="mt-2 w-11/12 mx-auto ">

  <div *ngIf="complaintTracking" class="p-3 ">
    <div class="bg-white move-left p-3 rounded-xl">
      <div class="flex items-center w-full  border-b-2 border-yellow-400 pb-2 mb-6">
        <div class="text-xl">{{ "Kumbu kumbu namba ya mrejesho "|concat|translate }}</div>
        <div class="text-xl text-primary-500">: {{ trackNumber }}</div>
      </div>

      <div class="mt-2 grid md:grid-cols-3 grid-cols-1 gap-3">
        <div class="grid grid-cols-1 col-span-2 gap-2">
          <div class="flex flex-col">
            <div class="bg-light_primary text-gray-700 font-bold px-2 py-3 rounded-md mb-2">
              {{ 'Aina ya mrejesho'|concat|translate }}
            </div>
            <p class="pb-2 border-b">{{ complaintTracking.feedbackType }}</p>
          </div>
          <div class="flex flex-col">
            <div class="bg-light_primary text-gray-700 font-bold px-2 py-3 rounded-md mb-2">
              {{ 'Kichwa cha mrejesho'|concat|translate }}
            </div>
            <p class="pb-2 border-b">{{ complaintTracking.title }}</p>
          </div>
          <div class="flex flex-col">
            <div class="bg-light_primary text-gray-700 font-bold px-2 py-3 rounded-md mb-2">
              {{ 'Maelezo ya mrejesho'|concat|translate }}
            </div>
            <p class="pb-2 border-b">{{ complaintTracking.description }}</p>
          </div>
          <div *ngIf="complaintTracking.status" class="flex flex-col">
            <div class="bg-gray-50 text-gray-700 font-bold p-2 rounded-md mb-2">
              Status
            </div>
            <p class="pb-2 border-b">{{ complaintTracking.status  | removeUnderscore }}</p>
          </div>

          <div *ngIf="complaintTracking.registrationDate" class="flex flex-col">
            <div class="bg-gray-50 text-gray-700 font-bold p-2 rounded-md mb-2">
              Registration Date
            </div>
            <p class="pb-2 border-b">{{ complaintTracking.registrationDate }}</p>
          </div>

          <div class="flex flex-col" *ngIf="!!complaintTracking?.legalOpinions?.length">
            <div class="bg-light_primary text-gray-700 font-bold px-2 py-3 rounded-md mb-2">
              {{ 'Legal Opinion'|concat|translate }}
            </div>
            @for (opinion of complaintTracking?.legalOpinions; track opinion) {
              <p class="pb-2 border-b">{{ opinion?.explaination }}</p>
            }
          </div>
          <div *ngIf="complaintTracking.closingRemarks" class="flex flex-col col-span-2">
            <div class="bg-gray-50 text-gray-700 font-bold p-2 rounded-md mb-2">
              Closing Remarks
            </div>
            <p class="pb-2 border-b">{{ complaintTracking.closingRemarks || 'N/A' }}</p>
          </div>


        </div>

        <div class="grid grid-cols-1 col-span-1 gap-2">
          <div class="flex flex-col relative">
            <div class="bg-light_primary text-gray-700 font-bold px-2 py-3 rounded-md mb-2">
              {{ 'Hali ya mrejesho'|concat|translate }}
            </div>
            @for (stats of complaintTracking?.feedbackHistory; track stats) {
              <div class="flex px-4 text-primary-500 relative">
                <div class="h-[140%] transition-all duration-1000 ml-2 w-[2px]
                     bg-gray-300 relative">
                  <div class="w-[20px] h-[20px] absolute top-0 -left-[10px] rounded-full bg-gradient-to-b from-green-400 to-green-600"></div>
                </div>

                <div class="flex flex-col gap-1 py-3">
                  <div class="px-4 text-lg">{{ stats?.action |concat|translate }}</div>
                  <div class="flex gap-1 px-4 items-center">
                    <mat-icon>
                      today
                    </mat-icon>
                    <span>
                    {{ stats?.actionDate | date:'MMM dd, YYYY' }}
                  </span>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="flex flex-col mt-4">
            <div class="bg-light_primary text-gray-700 font-bold px-2 py-3 rounded-md mb-2">
              {{ 'Tathmini huduma yetu '|concat|translate }}
            </div>
            <p class="p-2">{{ 'Tunaomba maoni yako ya namna tulivyokujibu kwenye mrejesho uliotutumia'}}</p>

            <img src="/assets/images/qrcode.svg"
                 alt="Rate"
                 class="h-20 lg:h-40 md:h-30 sm:h-14 cursor-pointer self-center" />

            <a href="https://emrejeshov2.all.tz/login"
               target="_blank"
              class="no-underline w-11/12 mx-auto mt-2 rounded-md text-md flex items-center justify-center bg-primary-500/80 text-secondary-500 py-3 px-2 cursor-pointer"
            >
              <span class="font-semibold text-md text-center">{{ "Scan au bofya kutathmini" | concat | translate }}</span>
            </a>
          </div>
        </div>

      </div>
    </div>


  </div>

  @if (!complaintTracking){
    <div class="bg-light_primary p-6 mt-5 text-center rounded-lg w-8/12 mx-auto flex flex-col items-center justify-center  gap-3 ">
      <mat-icon class="scale-150 animate-bounce duration-1000">clear_all</mat-icon>
      <span>{{'Hakuna taarifa iliyopatikana' | concat|translate}}</span>
    </div>
  }

  <div class="mt-2 mx-2 move-left" *ngIf="currentClient">
    <app-data-table-hybrid
      [columnHeader]="tableColumns"
      [hasActionsColumn]="true"
      [isPageable]="true" [searchFields]="[]" [tableData]="myFeedbacks">
      <ng-template #actions let-data="data">
        <div class="action-icons">
        <span [routerLink]="'/feedback-follow-up/'+ data?.uniqueId" class="icon-holder color-primary"
              matTooltip="{{ 'View More' | concat | translate }}" matTooltipPosition="left"
              matTooltipClass="primary-tooltip">
                      <mat-icon svgIcon="list"></mat-icon>
                  </span>
        </div>
      </ng-template>
    </app-data-table-hybrid>
  </div>
</div>




